import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { getCamerasBySiteAlerts } from "../Alerts/AlertsUtils/getCamerasBySiteAlerts";

export const SiteDropDownHM = ({
  userFilters,
  setUserFilters,
  siteOptions,
  setCameraOptions,
  setCameraDropDownValue,
  siteDropDownValue,
  setSiteDropDownValue,
  loadingSites,
  setLoadingCameras,
  navBarCollapsed,
  navigate,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  siteOptions: any;
  setCameraOptions: Dispatcher<any>;
  setCameraDropDownValue: Dispatcher<string>;
  siteDropDownValue: string;
  setSiteDropDownValue: Dispatcher<string>;
  loadingSites: boolean;
  setLoadingCameras: Dispatcher<boolean>;
  navBarCollapsed: boolean;
  navigate: NavigateFunction;
}) => {
  const siteIdsMap = new Map();
  const siteNamesMap = new Map();
  siteOptions.forEach((object: any) => {
    siteIdsMap.set(object.name, object.id);
  });
  siteOptions.forEach((object: any) => {
    siteNamesMap.set(object.id, object.name);
  });

  const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");

  const parentIdsMap = new Map();
  parentAccounts.forEach((object: any) => {
    parentIdsMap.set(object.name, object.id);
  });

  return (
    <div>
      <Autocomplete
        disablePortal
        options={
          siteOptions[0]
            ? siteOptions.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          userFilters.site
            ? {
                id: Number(userFilters.site),
                name: siteNamesMap.get(Number(userFilters.site)),
                index: siteOptions.findIndex(
                  (obj: any) => obj.id === Number(userFilters.site)
                ),
              }
            : null
        }
        loading={loadingSites}
        onChange={(event, value: any) => {
          if (value !== null) {
            setSiteDropDownValue(value.name);
            setCameraDropDownValue("");
            getCamerasBySiteAlerts(
              [value.id],
              navigate,
              setCameraOptions,
              setLoadingCameras
            );
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site: value.id,
                camera: "",
              };
            });
          } else {
            setSiteDropDownValue("");
            setCameraDropDownValue("");
            setCameraOptions([]);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site: "",
                camera: "",
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSites ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={!navBarCollapsed ? { width: 175 } : { width: 200 }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
